
import React from 'react';
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

export const PaymentTableHeader = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Date</TableHead>
        <TableHead>Type</TableHead>
        <TableHead>Recipient</TableHead>
        <TableHead>Description</TableHead>
        <TableHead>Amount</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Payment Method</TableHead>
        <TableHead>Reference</TableHead>
      </TableRow>
    </TableHeader>
  );
};
